<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-66 md-xsmall-size-80 mx-auto">
      <simple-wizard>
        <template slot="header">
          <h3 class="title">
            Nueva Reclamación
            <span
              v-if="issue.cliente.razon_social!=null"
            >- {{issue.cliente.nombre_busqueda}}</span>
          </h3>
        </template>

        <wizard-tab :before-change="() => validateStep('clientStep')">
          <template slot="label">Cliente</template>
          <cliente-step ref="clientStep" @on-validated="onStepValidated" :issue="issue"></cliente-step>
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('seleccionAlbaranStep')">
          <template slot="label">Albarán</template>
          <seleccion-pedido-step
            ref="seleccionAlbaranStep"
            @on-validated="onStepValidated"
            :issue="issue"
          ></seleccion-pedido-step>
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('seleccionProductosStep')">
          <template slot="label">Productos</template>
          <seleccion-productos
            ref="seleccionProductosStep"
            @on-validated="onStepValidated"
            :issue="issue"
            :reload="reload"
          ></seleccion-productos>
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('incidenciastep')">
          <template slot="label">Incidencia</template>
          <incidencia-step ref="incidenciastep" @on-validated="wizardComplete" :issue="issue"></incidencia-step>
        </wizard-tab>
      </simple-wizard>
    </div>
  </div>
</template>
<script>
import ClienteStep from "./ClienteStep";
import SeleccionPedidoStep from "./SeleccionPedidoStep";
import IncidenciaStep from "./IncidenciaStep";
import SeleccionProductos from "./SeleccionProductos";
import swal from "sweetalert2";
import { SimpleWizard, WizardTab } from "@/components";
import { reclamacionService } from "@/_services";

export default {
  data() {
    return {
      issue: {
        cliente: {
          _id: null,
          razonSocial: null,
          email: null,
          contact: null
        },
        albaranes: [],
        selectedAlbaranes: [],
        productos: [],
        selectedProductos: []
      },
      reload: 0
    };
  },
  components: {
    SeleccionPedidoStep,
    IncidenciaStep,
    SimpleWizard,
    WizardTab,
    ClienteStep,
    SeleccionProductos
  },
  methods: {
    validateStep(ref) {
      this.reload++;
      return this.$refs[ref].validate();
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    buildContract() {
      let contract = {
        clienteId: this.issue.cliente._id,
        productos: []
      };
      for (
        let index = 0;
        index < this.issue.selectedProductos.length;
        index++
      ) {
        const element = this.issue.selectedProductos[index];
        contract.productos.push({
          codigo: element.producto.codigo,
          albaranId: element.albaranId,
          unidadesAfectadas: element.cantidad_afectadas,
          incidencia: {
            subtipo: element.incidencia.tipo
          }
        });
      }
      return contract;
    },
    wizardComplete() {
      let contract = this.buildContract();
      reclamacionService.enviarReclamacion(contract).then(res => {
        if (!res.ok) {
          res
            .json()
            .then(data => {
              swal({
                title: "¡Se ha producido un error!",
                type: "error",
                text: data.error,
                confirmButtonClass: "md-button md-error",
                buttonsStyling: false
              });
            })
            .catch(() => {
              swal({
                title: "¡Se ha producido un error!",
                type: "error",
                text: "Por favor contacte con el administrador",
                confirmButtonClass: "md-button md-error",
                buttonsStyling: false
              });
            });
          return;
        } else {
          swal({
            title: "¡La reclamación ha sido registrada!",
            text: "En breve nos pondremos manos a la obra.",
            type: "success",
            confirmButtonClass: "md-button md-success",
            buttonsStyling: false
          }).then(() => {
            this.$router.push("/dashboard");
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.swal-button-error {
  background-color: #f27474 !important;
}
</style>
